var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"typeMgr"},[_c('type-list',{on:{"selectedAttr":_vm.selectedAttr}}),_c('attr-detail',{attrs:{"formData":_vm.formData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }